<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">	
         <el-input placeholder="구글OTP" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
		<el-button type="danger" size="mini" @click="deleteAll">선택삭제</el-button>
    <div class="ml-auto">
        <el-form inline ref="form" :model="searchform">

      

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" placeholder="타이틀선택" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input placeholder="키워드" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
          <el-form-item  class="mb-0" style="margin-right:0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="시작"
                  end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd"style="width:200px" >
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">검색</el-button>  
          </el-form-item>
      </el-form>
    </div>
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
      border class="mt-2" @selection-change="handleSelectionChange"  empty-text="데이타가 없습니다">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
         <el-table-column
        label="아이디" prop="mem_id" align="center" width="120">
          <template slot-scope="scope">
            
             <span @click="openModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}}</span>
          </template>
      </el-table-column> 

      <el-table-column
        label="이름" prop="mem_name" align="center" width="120">
          <template slot-scope="scope">
            
             {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
          </template>
      </el-table-column> 
      
      <el-table-column
        
        label="날짜" prop="add_time" align="center">
      </el-table-column>
      <el-table-column
        
        label="출석일" prop="addm" align="center">
      </el-table-column>
    
    <el-table-column
        
        label="지급" prop="days" align="center">
        <template slot-scope="scope"> 
           {{dayObj[scope.row.days]}}
        </template>
      </el-table-column>
    

    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
				
				

			
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';

    export default {
     components: {
      layer
    },
    	data(){

    		return{  
                otp:'',
             level_title:{
              '-2':'블랙',
              '-1':'대기',
              '0':'기본'             
            },  
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
            bg:window.sessionStorage.getItem('bg'),
    			formLoading:false,
          idDialogVisible: false,
    			total:0,
    			size:0,
    			loading: false,
    			tableData: [],
    			currentPage:1,
			    multipleSelection:[],
          dayObj:{
            '0':'',
            '1':'지급'
          },
            searchform:{
            keyword:'',
            time:[],
            searchOptions:[
                
          
            {
              label:'아이디',
              value:'mem_id'
            },{
              label:'출석일',
              value:'addm'
            }
           
           

            ],
          
            value:'',



          },
           pickerOptions: {
          },
          shortcuts: [{
            text: '최근한주',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근한달',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근3개월',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
			   
   
    			}
	
    		},
    		created() {
    			this.getList();

		},
    	
    	methods:{
    		  // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         openModel(id){
            let pix=window.screen.width;
            let layerwidth='950px';
                if(pix<1200)
                {
                  layerwidth='95%';
                }
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: [layerwidth+'', '680px'],
           
        });
        },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			  searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                   this.$message('검색타이틀 선택하세요');
                   return;
                }
                this.currentPage=1;
          this.getList();
          
             

        },
    		getList(){
               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }   
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/dcheck_list?s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;
    			
    		
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data.data)
                     this.tableData =response.data.data.data
                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
            	

               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    		
    		
    		handleSelectionChange(val) {
    			//console.log(val)
                this.multipleSelection = val;

      },
    	  // 批量删除
			deleteAll(){
				this.$confirm('삭제하시겠습니까?', '알림', {
					confirmButtonText: '삭제',
					cancelButtonText: '취소',
					type: 'warning'
				}).then(() => {
					let token=window.sessionStorage.getItem('user');

					console.log('hh',this.multipleSelection);

                    let newids=[];

					 this.multipleSelection.forEach(item=>{
					 	
					 	//console.log('id',item.idx);
					 	newids.push(item.id);
					 });

					 console.log('newids',newids);

					this.$axios({
			                method:'post',
			                 data:{idx:newids,opt:this.otp},
			                url:this.domain+'/admin/dcheck_del',
			                'Accept': 'application/json',
			                headers: { 'Authorization': 'Bearer ' + token },
			                
			               
			            }).then((response) =>{ 
			            	
			            	if(response.data.code==200){
			            		this.$message({
					    				message:response.data.msg,
					    				type:'success'
			    					})
			            	}else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
			            	this.getList()
    
			            }).catch((error) =>{
			                console.log(error)       //请求失败返回的数据
			            })
           				
       

    			})

				
			}, 	
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

</style>


// WEBPACK FOOTER //
// src/views/dcheck/list.vue